/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { FaPen, FaTrash, FaRegFileExcel } from "react-icons/fa";
import { Link } from "react-router-dom";
import "./../../assets/css/style.css";
import colis_service from "../../services/colis-service";
import { formatDate } from "../../utils/date-utils";

const List_colis = () => {
  const [colis, setColis] = useState([]);
  const [statistics, setStatistics] = useState({
    total: 0,
    expedie: 0,
    arrive: 0,
    recupere: 0,
  });
  const [search, setSearch] = useState("");
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [filterMode, setFilterMode] = useState("");
  const [loading, setLoading] = useState(false);
  const [statsLoading, setStatsLoading] = useState(true);
  const [filterStatus, setFilterStatus] = useState(""); 
  const [exportLoading, setExportLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(null);
  const [statusUpdateLoading, setStatusUpdateLoading] = useState(null);
  const [message, setMessage] = useState({ text: "", type: "" });

  const STATUS_OPTIONS = {
    Expédié: ["Arrivé", "Récupéré"],
    Arrivé: ["Récupéré", "Expédié"],
    Récupéré: ["Expédié", "Arrivé"],
  };

  useEffect(() => {
    fetchStatistics();
    fetchColis();
  }, []);

  const fetchStatistics = async () => {
    setStatsLoading(true);
    try {
      const response = await colis_service.get();
      if (response && response.statistics) {
        setStatistics(response.statistics);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des statistiques", error);
      setMessage({
        text: `Erreur: ${error.message || "Une erreur est survenue"}`,
        type: "danger",
      });
    } finally {
      setStatsLoading(false);
    }
  };

  const fetchColis = async () => {
    setLoading(true);
    try {
      const options = {
        sortField: sortField,
        sortOrder: sortOrder,
        sendingOption: filterMode,
        searchQuery: search,
        status: filterStatus, 
      };

      const response = await colis_service.get(options);
      setColis(response.data);
    } catch (error) {
      console.error("Erreur lors de la récupération des colis", error);
      setMessage({
        text: `Erreur: ${error.message || "Une erreur est survenue"}`,
        type: "danger",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchColis();
    }, 500);

    return () => clearTimeout(timer);
  }, [search, sortField, sortOrder, filterMode,filterStatus]);

  const handleSearch = (event) => {
    setSearch(event.target.value);
  };

  const handleSortChange = (field, event) => {
    setSortField(field);
    setSortOrder(event.target.value);
  };

  const handleExport = async () => {
    setExportLoading(true);
    try {
      const response = await colis_service.exportData();
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `colis_export_${new Date().toISOString().split("T")[0]}.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
      setMessage({
        text: "Export réussi!",
        type: "success",
      });
    } catch (error) {
      console.error("Erreur lors de l'exportation des données", error);
      setMessage({
        text: `Erreur lors de l'exportation: ${
          error.message || "Une erreur est survenue"
        }`,
        type: "danger",
      });
    } finally {
      setExportLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer ce colis?")) {
      setDeleteLoading(id);
      try {
        await colis_service.delete(id);
        setColis(colis.filter((item) => item.id !== id));
        await fetchColis();
        await fetchStatistics();
        setMessage({
          text: "Colis supprimé avec succès!",
          type: "success",
        });
      } catch (error) {
        console.error("Erreur lors de la suppression", error);
        setMessage({
          text: `Erreur: ${error.message || "Une erreur est survenue"}`,
          type: "danger",
        });
      } finally {
        setDeleteLoading(null);
      }
    }
  };

  const handleStatusUpdate = async (id, newStatus) => {
    setStatusUpdateLoading(id);
    setLoading(true);

    try {
      await colis_service.update(id, { status: newStatus });
      await fetchColis();
      await fetchStatistics();
      setMessage({
        text: `Status du colis mis à jour: ${newStatus}`,
        type: "success",
      });
    } catch (error) {
      console.error("Erreur lors de la mise à jour du statut", error);
      setMessage({
        text: `Erreur: ${error.message || "Une erreur est survenue"}`,
        type: "danger",
      });
    } finally {
      setStatusUpdateLoading(null);
      setLoading(false);
    }
  };

  const StatisticLoadingSpinner = () => (
    <div className="d-flex justify-content-center align-items-center h-100">
      <span className="spinner-border" role="status" aria-hidden="true"></span>
    </div>
  );

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case "Expédié":
        return "bg-warning";
      case "Arrivé":
        return "bg-info";
      case "Récupéré":
        return "bg-success";
      default:
        return "bg-secondary";
    }
  };

  return (
    <div className="container-fluid full-height">
      <div className="text-center p-5">
        <h2 className="title mb-4">LISTE DE COLIS</h2>
        <div className="row justify-content-center">
          <div className="col-md-3 mb-4">
            <div className="card shadow-lg p-4 h-100">
              {statsLoading ? (
                <StatisticLoadingSpinner />
              ) : (
                <>
                  <h1 className="icon-service">{statistics.expedie}</h1>
                  <h5>Expédié</h5>
                </>
              )}
            </div>
          </div>

          <div className="col-md-3 mb-4">
            <div className="card shadow-lg p-4 h-100">
              {statsLoading ? (
                <StatisticLoadingSpinner />
              ) : (
                <>
                  <h1 className="icon-service">{statistics.arrive}</h1>
                  <h5>Arrivé</h5>
                </>
              )}
            </div>
          </div>

          <div className="col-md-3 mb-4">
            <div className="card shadow-lg p-4 h-100">
              {statsLoading ? (
                <StatisticLoadingSpinner />
              ) : (
                <>
                  <h1 className="icon-service">{statistics.recupere}</h1>
                  <h5>Récupéré</h5>
                </>
              )}
            </div>
          </div>

          <div className="col-md-3 mb-4">
            <div className="card shadow-lg p-4 h-100">
              {statsLoading ? (
                <StatisticLoadingSpinner />
              ) : (
                <>
                  <h1 className="icon-service">{statistics.total}</h1>
                  <h5 className="fw-bold text-service"> TOTAL</h5>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {message.text && (
        <div
          className={`alert alert-${message.type} alert-dismissible fade show`}
          role="alert"
        >
          {message.text}
          <button
            type="button"
            className="btn-close"
            onClick={() => setMessage({ text: "", type: "" })}
          ></button>
        </div>
      )}

      <div className="pb-2">
        <Link to="/admin/addColis">
          <button className="btn btn-primary">Ajouter +</button>
        </Link>
        <button
          className="btn btn-success mx-2"
          onClick={handleExport}
          disabled={exportLoading}
        >
          {exportLoading ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Exportation...
            </>
          ) : (
            <>
              Exporté en excel <FaRegFileExcel />
            </>
          )}
        </button>
      </div>

      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="d-flex">
          <select
            className="form-select w-auto"
            onChange={(e) => handleSortChange("client_code", e)}
            value={sortField === "client_code" ? sortOrder : ""}
          >
            <option value="">Code Client</option>
            <option value="asc">Croissant</option>
            <option value="desc">Décroissant</option>
          </select>

          <select
            className="form-select w-auto mx-2"
            onChange={(e) => handleSortChange("user_name", e)}
            value={sortField === "user_name" ? sortOrder : ""}
          >
            <option value="">Nom</option>
            <option value="asc">A-Z</option>
            <option value="desc">Z-A</option>
          </select>

          <select
            className="form-select w-auto"
            onChange={(e) => setFilterMode(e.target.value)}
            value={filterMode}
          >
            <option value="">Mode d'envoi</option>
            <option value="Aérien_Normal">Aérien normal</option>
            <option value="Aérien_Express">Aérien express</option>
            <option value="Envoi_Maritime">Envoi maritime</option>
          </select>
          <select
            className="form-select w-auto mx-2"
            onChange={(e) => setFilterStatus(e.target.value)}
            value={filterStatus}
          >
            <option value="">Status</option>
            <option value="Expédié">Expédié</option>
            <option value="Arrivé">Arrivé</option>
            <option value="Récupéré">Récupéré</option>
          </select>
        </div>
        <input
          type="text"
          className="form-control w-25"
          placeholder="Rechercher..."
          onChange={handleSearch}
          value={search}
        />
      </div>

      <table className="table table-bordered text-center">
        <thead>
          <tr className="table-dark">
            <th>Code client</th>
            <th>Nom</th>
            <th>Numéro colis</th>
            <th>Poids(kg)</th>
            <th>Dimensions(m³)</th>
            <th>Prix(Ariary)</th>
            <th>Mode d'envoi</th>
            <th>Status</th>
            <th>Date de départ</th>
            <th>Date d'arrivée</th>
            <th colSpan={2}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan="12" className="text-center">
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Chargement...
              </td>
            </tr>
          ) : colis.length === 0 ? (
            <tr>
              <td colSpan="12" className="text-center">
                Aucun résultat trouvé
              </td>
            </tr>
          ) : (
            colis.map((c) => (
              <tr key={c.id}>
                <td>{c.client_code}</td>
                <td>{c.user_name}</td>
                <td>{c.colis_number}</td>
                <td>{c.weight}</td>
                <td>{c.dimension}</td>
                <td>{c.price}</td>
                <td>{c.sending_option}</td>
                <td>
                  {statusUpdateLoading === c.id ? (
                    <div className="d-flex justify-content-center">
                      <span
                        className="spinner-border spinner-border-sm text-primary"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    </div>
                  ) : (
                    <select
                      className={`form-select form-select-sm ${getStatusBadgeClass(
                        c.status
                      )} text-white`}
                      value={c.status}
                      onChange={(e) => handleStatusUpdate(c.id, e.target.value)}
                      // disabled={c.status === "Récupéré" || loading}
                      style={{
                        cursor: c.status === "Récupéré" ? "default" : "pointer",
                        appearance: "none",
                        WebkitAppearance: "none",
                        MozAppearance: "none",
                        textAlignLast: "center",
                      }}
                    >
                      <option value={c.status} className="text-dark">
                        {c.status}
                      </option>
                      {STATUS_OPTIONS[c.status]?.map((status) => (
                        <option
                          key={status}
                          value={status}
                          className="text-dark"
                        >
                          {status}
                        </option>
                      ))}
                    </select>
                  )}
                </td>
                <td>{formatDate(c.departure_date)}</td>
                <td>{formatDate(c.arrival_date)}</td>
                <td>
                  <Link to={`/admin/updateColis/${c.id}`}>
                    <button className="btn btn-light text-success">
                      <FaPen />
                    </button>
                  </Link>
                </td>
                <td>
                  <button
                    className="btn btn-light text-danger"
                    onClick={() => handleDelete(c.id)}
                    disabled={deleteLoading === c.id}
                  >
                    {deleteLoading === c.id ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : (
                      <FaTrash />
                    )}
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default List_colis;
